<!-- Card -->
<section class="card">
  <!-- Body -->
  <div class="card-body">
    <role-permissions-form
      *ngIf="rolePermissions$ | async"
      (onSubmit)="onSubmit($event)"
      [rolePermissions]="rolePermissions$ | async"
    >
    </role-permissions-form>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
